import React, { Component } from 'react'
import { Layout, Tabs } from 'antd'
import { Route, Switch } from 'react-router-dom'
import Home from '../components/Home'
import Profile from '../components/Profile'
import LoadingSpinner from '../components/LoadingSpinner'
import LoginComponent from '../components/LoginComponent'
import Auth from '../auth/Auth'
import { Link } from 'react-router-dom'
import SideMenu from './SideMenu'
import AuthenticatedRoute from './AuthenticatedRoute'
import { withRouter } from 'react-router'
const TabPane = Tabs.TabPane

const handleAuthentication = ({ location }) => {
  if (/access_token|id_token|error/.test(location.hash)) {
    Auth.handleAuthentication()
  }
}

const { Header, Content, Footer, Sider } = Layout

class AppContainer extends Component {
  handleTabChange = key => {
    const { history } = this.props
    history.push(key)
  }

  render() {
    const { location, match } = this.props
    return (
      <Layout className="automech-layout">
        <SideMenu />
        <Layout style={{ marginLeft: 70 }}>
          <Header>Header</Header>
          <Content className="content">
            <Switch>
              <Route exact path="/login" component={LoginComponent} />
              <Route
                exact
                path="/authcallback"
                render={props => {
                  handleAuthentication(props)
                  return <LoadingSpinner />
                }}
              />
              <AuthenticatedRoute path="/profile" component={Profile} />
              <AuthenticatedRoute path="/" component={Home} />
            </Switch>
          </Content>
          <Footer>Footer</Footer>
        </Layout>
      </Layout>
    )
  }
}

export default withRouter(AppContainer)



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js